import styled from 'styled-components';
import { rem } from 'polished';

// eslint-disable-next-line import/no-cycle
import NewsWidget from '../../News/NewsWidget';
import Traffic from '../../MiniWidgetList/MiniWidgets/Traffic';
import Weather from '../../MiniWidgetList/MiniWidgets/Weather';
import NewsTab from '../../../containers/New/NewsTab';

/** home */
const StyledNewsWidget = styled(NewsWidget)`
  .NewsWidget-name {
    font-size: ${rem('21px')};
    color: ${props => props.theme.colors.light};
  }
  .NewsWidget-notifications {
    font-size: ${rem('14px')};
    color: ${props => props.theme.colors.light};
    margin-bottom: ${rem('10px')};
  }
  .NewsWidget-link {
    color: ${props => props.theme.colors.light};
  }
  .NewsWidget-miniWidget {
    display: flex;
  }
`;

/** MiniWidgets */
const StyledTraffic = styled(Traffic)`
  margin: 0 ${rem('10px')} ${rem('10px')} 0;
  max-height: ${rem('120px')};

  .Traffic-header,
  .WidgetMiniUpdate {
    display: none;
  }
  .TraficStart-text {
    font-size: ${rem('12px')};
  }
  .TrafficInfo-text {
    font-size: ${rem('12px')};
    font-family: ${props => props.theme.fonts.medium};
  }
`;

const StyledWeather = styled(Weather)`
  margin: 0 0 ${rem('10px')} 0;
  max-height: ${rem('120px')};

  .Weather-header,
  .WidgetMiniUpdate {
    display: none;
  }
  .WeatherInfo-name {
    font-size: ${rem('12px')};
    font-family: ${props => props.theme.fonts.medium};
  }
`;

/** Noticias */
const StyledNewsTab = styled(NewsTab)`
  width: auto;
  /* player */
  .a3mod_player {
    .icon {
      background-color: rgba(0, 0, 0, 0.6);
      border: ${rem('2px')} ${props => props.theme.colors.light} solid;
      width: ${rem('45px')};
      height: ${rem('45px')};

      &:before {
        font-size: 1rem;
      }
    }
  }
  .NewsItem-published,
  .TagCategory,
  .OptionsNews {
    display: none;
  }
  .NewsItem-box {
    border: none;
    margin-bottom: ${rem('15px')};
    padding-bottom: 0;
  }
  .NewsItem-title {
    font-size: ${rem('14px')};
    margin-bottom: ${rem('8px')};
    line-height: ${rem('17px')};
  }
  .NewsItem-titleLink {
    margin-bottom: 0;
  }
  .NewsItem-description {
    font-size: ${rem('14px')};
    line-height: ${rem('20px')};
    margin-bottom: 0;
  }
  .NewsItem-boxOptions {
    margin: 0;
    padding: ${rem('10px')} 0;
  }
  .credit-avatar {
    width: ${rem('40px')};
    height: ${rem('40px')};
    font-size: ${rem('15px')};
    border-width: ${rem('2px')};
  }
  .avatar {
    width: ${rem('30px')};
    height: ${rem('30px')};
    border-width: ${rem('2px')};
  }
  .NewsTab-title {
    line-height: ${rem('17px')};
  }
  .NewsTab-detail {
    line-height: ${rem('20px')};
  }
`;

export { StyledNewsWidget, StyledTraffic, StyledWeather, StyledNewsTab };
